import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewHostPageNew from "../../components/User/ViewUserPageNew";



const ViewHostPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb  id="title" title2="Host Management" link2="/host" title="View Host" />

        {/* AddUserLayer */}
        <ViewHostPageNew roles="host" />


      </MasterLayout>
    </>
  );
};

export default ViewHostPage;
